module.exports = __webpack_public_path__ + "img/onConnectIcon.e7d162bc.svg";